import {AfterViewInit, Component, OnInit} from '@angular/core';
import {
    ControlService,
    IconService,
    ScheduleIntervalsService,
    SubtitlesService,
} from "../../../core";
import {MenuElementType120, MenuType} from "../../../models";

@Component({
    selector: 'schedule-intervals',
    templateUrl: './schedule-intervals.component.html',
    styleUrls: ['./schedule-intervals.component.scss']
})
export class ScheduleIntervalsComponent  implements OnInit, AfterViewInit {
    constructor(
        public control: ControlService,
        private icon: IconService,
        private subtitles: SubtitlesService,
        public scheduleIntervals: ScheduleIntervalsService,
    ) {
    }

    ngOnInit() {
        const elementVal = this.control.elementVal.getValue() as MenuElementType120;
        this.scheduleIntervals.setDay(elementVal.params.days[0],0);
    }

    ngAfterViewInit() {
        this.control.setOverflow();
    }

    setIcon(val: number | MenuType): string {
        if (val === null) return;

        return this.icon.setIcon(val);
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }
}
